/*
  The md breakpoint, in JavaScript (§6.3).

  768px is Tailwind's md, pinned in the spec because the migration crosses two systems
  and MUI's equivalent is 900. The two must not drift, so the query is written against
  Tailwind's number and nothing reads a MUI theme.

  Stacked mode is a different DOM — a list of cards, no <th>, a sort control outside the
  table — rather than the same table restyled, so the decision has to be made in JS.

  The matchMedia machinery itself moved to components/useMediaQuery in task 15, which had
  the second copy of it (MUI's useMediaQuery, behind src/hooks) to retire. This file keeps
  the named query and its four exports; the synchronous initial read and the legacy
  addListener fallback are unchanged, they just live one module down.
*/

import {
  matchesMediaQuery,
  useMediaQueryMatches,
  watchMediaQuery,
} from "components/useMediaQuery";

/* Tailwind's md is min-width 768px, so stacked is everything below it. */
export const STACKED_LAYOUT_QUERY = "(max-width: 767.98px)";

/* No usable matchMedia resolves to the table: it is the layout that shows every column. */
export const isStackedWidth = (): boolean =>
  matchesMediaQuery(STACKED_LAYOUT_QUERY);

export const watchStackedWidth = (onChange: (stacked: boolean) => void) =>
  watchMediaQuery(STACKED_LAYOUT_QUERY, onChange);

export const useIsStacked = (): boolean =>
  useMediaQueryMatches(STACKED_LAYOUT_QUERY);
